import { OdooContext } from "OdooProvider";
import { useContext } from "react";

const OrdersView = ({ data, currencySymbol }) => {
  const { odooUrl } = useContext(OdooContext);

  return (
    <div className="-mx-2 text-sm">
      <table className="font-code whitespace-nowrap">
        <thead>
          <tr>
            <th>Due Date</th>
            <th>Plan Date</th>
            <th>Name</th>
            <th>Partner</th>
            <th className="text-right">Order Amount</th>
            <th className="text-right">Uninvoiced/Unbilled Amount</th>
          </tr>
        </thead>
        <tbody>
          {data.map((i, index) => (
            <tr key={index} className="border-y dark:border-gray-700">
              <td>{i.due_date}</td>
              <td>{i.date_planned}</td>
              <td>
                <a
                  href={`${odooUrl}/odoo/sales/${i.id}`}
                  rel="noreferer"
                  target="_blank"
                >
                  {i.name}
                </a>
              </td>
              <td>{i.partner_id[1]}</td>
              <td className="text-right">
                {i.currency}{" "}
                {i.amount.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </td>
              <td className="text-right">
                {i.uninvoiced.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
                {currencySymbol}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OrdersView;
